// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"69":"8e89e392","994":"ec133e98"}[chunkId] + ".chunk.js";
};